// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"150":"c8f422f7","801":"83354ad4"}[chunkId] + ".css";
};